import { Route } from 'react-router-dom';
import { SALES_PERMISSIONS } from '@invento/shared';
import { PermissionGuard } from '@/navigation/guards/permission-guard';
import { lazyNamed } from '../lazy-named';
import { TenantChromeFreeRouteFrame } from './route-frames';

const SalesPosPage = lazyNamed(() => import('@/features/sales'), 'SalesPosPage');

export function posRoutes() {
  return (
    <Route element={<TenantChromeFreeRouteFrame />}>
      <Route
        path="sales/pos"
        element={
          <PermissionGuard required={SALES_PERMISSIONS.POS_CREATE}>
            <SalesPosPage />
          </PermissionGuard>
        }
      />
    </Route>
  );
}
